/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const MethodMatchMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
  Head: "HEAD",
  Options: "OPTIONS",
} as const;
export type MethodMatchMethod = ClosedEnum<typeof MethodMatchMethod>;

/**
 * Matches when the request method is one of the listed methods.
 */
export type MethodMatch = {
  methods: Array<MethodMatchMethod>;
};

/** @internal */
export const MethodMatchMethod$inboundSchema: z.ZodNativeEnum<
  typeof MethodMatchMethod
> = z.nativeEnum(MethodMatchMethod);
/** @internal */
export const MethodMatchMethod$outboundSchema: z.ZodNativeEnum<
  typeof MethodMatchMethod
> = MethodMatchMethod$inboundSchema;

/** @internal */
export const MethodMatch$inboundSchema: z.ZodType<
  MethodMatch,
  z.ZodTypeDef,
  unknown
> = z.object({
  methods: z.array(MethodMatchMethod$inboundSchema),
});
/** @internal */
export type MethodMatch$Outbound = {
  methods: Array<string>;
};

/** @internal */
export const MethodMatch$outboundSchema: z.ZodType<
  MethodMatch$Outbound,
  z.ZodTypeDef,
  MethodMatch
> = z.object({
  methods: z.array(MethodMatchMethod$outboundSchema),
});

export function methodMatchToJSON(methodMatch: MethodMatch): string {
  return JSON.stringify(MethodMatch$outboundSchema.parse(methodMatch));
}
export function methodMatchFromJSON(
  jsonString: string,
): SafeParseResult<MethodMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MethodMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MethodMatch' from JSON`,
  );
}
